<template>
  <div class="guild-select-card">
      <img width="64" height="64" v-bind:src="guild.icon ? `https://cdn.discordapp.com/icons/${guild.id}/${guild.icon}.png?size=512` : `https://img.icons8.com/plasticine/2x/discord-logo.png`" alt="guild icon" class="guild-select-card-img">
      <h3 class="guild-select-card-name">{{ parseName(guild.name) }}</h3>
      <a v-bind:href="`/dashboard/${guild.id}`" v-if="type === `e`" class="button-green"><i class="fas fa-cog"></i> Settings</a>
      <a @click="inviteBot(guild.id)" href="#"  v-if="type === `i`" class="button-primary"><i class="fas fa-plus"></i> Invite Bot</a>
  </div>
</template>

<script>
export default {
  name: "GuildCard",
  props: ["guild", "type"],
  methods: {
    parseName: function (name) {
      if (name.length > 16) {
        var res = "";
        for (var i = 0; i < name.length; i++) {
          if (i === 16) break;
          res += name[i];
        }
        res += "...";
        return res;
      }
      return name;
    },
    inviteBot: function (id) {
      const url = `http://discordapp.com/oauth2/authorize?client_id=${this.$botId}&response_type=code&disable_guild_select=true&redirect_uri=${this.$callbackURL.split("/callback")[0]}/invitation&scope=bot%20applications.commands&permissions=469888255&guild_id=${id}`;
      const guildWindow = window.open("", "_blank", "width=450,height=600");
      guildWindow.location.href = url;

      var inter = setInterval(() => {
        try {
          if (!guildWindow.closed) {
            if (guildWindow.location.href.includes("error=access_denied")) {
              guildWindow.close();
            } else if (guildWindow.location.href.includes("code=")) {
              guildWindow.close();
              this.$emit("refresh");
            }
          } else {
            clearInterval(inter);
          }
        } catch (e) {
          // Yes.
        }
      }, 100);
    } 
  }
}
</script>

<style scoped>
  .guild-select-card {
    padding: 1em;
    width: 20em;
    background-color: var(--light-grey-blue);
    height: 9em;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 1em;
    word-break: break-all!important;
    transition: 0.5s;
    -webkit-box-shadow: 10px 10px 66px -5px rgba(0, 0, 0, 0.46);
    -moz-box-shadow: 10px 10px 66px -5px rgba(0, 0, 0, 0.46);
    box-shadow: 10px 10px 66px -5px rgba(0, 0, 0, 0.46);
    transform: translateY(150px);
    opacity: 0;
    animation: come-in 0.6s ease forwards;
  }

  .guild-select-card-item {
    padding: 1em;
    width: 23em;
    background-color: var(--light-grey-blue);
    height: 9em;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 1em;
    word-break: break-all!important;
    transition: 0.5s;
    -webkit-box-shadow: 10px 10px 66px -5px rgba(0, 0, 0, 0.46);
    -moz-box-shadow: 10px 10px 66px -5px rgba(0, 0, 0, 0.46);
    box-shadow: 10px 10px 66px -5px rgba(0, 0, 0, 0.46);
  }

  .guild-select-card-item .guild-select-card-name-item {
    position: relative;
    top: -0.4em;
  }

  .guild-select-card-img {
    border-radius: 50%;
    position: relative;
    left: -5.6em;
    top: 2.2em;
    object-fit: cover;
  }

  .guild-select-card-name {
    position: relative;
    top: -3em;
    left: 2em;
    font-size: 1rem;
  }
</style>